/* eslint-disable */
import React, { useLayoutEffect, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import bar from './devsBar.module.css';
import p from './devsPop.module.css';

// DevsPop — one portalled popover of the Developments bar. Placed under its anchor
// ([data-anchor=key]) on a screen, a bottom sheet on a phone (<= 760px). Rendered into
// document.body so it carries its own tokens (.tok — a portal does not inherit .hubRoot).
// data-shell-pop keeps ShellRoot's outside-click from closing it; Escape closes (ShellRoot)
// and focus returns to the trigger; ↑/↓ walk the rows.
const phone = () => window.matchMedia('(max-width:760px)').matches;

export default function DevsPop({ anchorKey, kind, label, align = 'l', onClose, children, fallbackKey }) {
  const ref = useRef(null);
  const place = () => {
    const el = ref.current; if (!el) return;
    if (phone()) { el.classList.add(p.sheet); el.style.left = ''; el.style.top = ''; el.style.removeProperty('--avail'); return; }
    el.classList.remove(p.sheet);
    let a = document.querySelector(`[data-anchor="${CSS.escape(anchorKey)}"]`);
    if ((!a || !a.getClientRects().length) && fallbackKey) a = document.querySelector(`[data-anchor="${fallbackKey}"]`);
    const vw = window.innerWidth, w = el.offsetWidth;
    if (!a || !a.getClientRects().length) { el.style.left = Math.max(12, (vw - w) / 2) + 'px'; el.style.top = '120px'; return; }
    const r = a.getBoundingClientRect();
    let l = align === 'r' ? r.right - w : r.left; l = Math.max(12, Math.min(l, vw - w - 12));
    const t = r.bottom + 8;
    el.style.left = l + 'px'; el.style.top = t + 'px';
    el.style.setProperty('--avail', Math.max(220, window.innerHeight - t - 14) + 'px');
  };
  useLayoutEffect(place);
  useEffect(() => {
    const on = () => place();
    window.addEventListener('resize', on); window.addEventListener('scroll', on, true);
    const key = (e) => {
      if (e.key === 'Escape') { const a = document.querySelector(`[data-anchor="${CSS.escape(anchorKey)}"]`); setTimeout(() => a && a.focus && a.focus({ preventScroll: true }), 0); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const el = ref.current; if (!el) return;
      const items = Array.from(el.querySelectorAll('[data-nav]')).filter((x) => x.getClientRects().length); if (!items.length) return;
      e.preventDefault(); const i = items.indexOf(document.activeElement);
      items[i < 0 ? 0 : (i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus();
    };
    document.addEventListener('keydown', key);
    return () => { window.removeEventListener('resize', on); window.removeEventListener('scroll', on, true); document.removeEventListener('keydown', key); };
  }, [anchorKey]); // eslint-disable-line
  return createPortal(
    <div className={bar.tok} data-devs-pop>
      <div className={p.scrim} aria-hidden="true" />
      <div ref={ref} className={`${p.pop} ${(kind || '').split(' ').map((k) => p[k]).join(' ')}`} role="dialog" aria-label={label} data-shell-pop data-al={align} onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>,
    document.body,
  );
}
